import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';

interface Insurance {
  primary_lang: string;
  secondary_lang: string;
}

export interface InsuranceState {
  insurances: Insurance[];
}

@Injectable()
export class InsuranceStore extends ComponentStore<InsuranceState> {
  constructor() {
    super({ insurances: [] });
  }

  public readonly addInsurance = this.updater((state, insurance: Insurance) => {
    return { insurances: [...state.insurances, insurance] };
  });

  public readonly rmInsurance = this.updater((state, idx: number) => {
    return { insurances: state.insurances.filter((_, i) => i !== idx) };
  });

  public updateInsurance(idx: number, insurance: Insurance) {
    this.updater((state, insurance: Insurance) => {
      state.insurances.splice(idx, 1, insurance);
      return { insurances: [...state.insurances] };
    })(insurance);
  }
}
